import { Button, Tooltip } from 'antd';
import React from 'react';
import { DownloadOutlined } from '@ant-design/icons';
import { exportToExcel } from '@/utils';

function ExcelExporter({
  data,
  fileName,
  sheetName = 'Sheet1',
  columnMapping,
  tooltip = 'Export',
  groupedHeaders,
}) {
  const handleExport = () => {
    if (data) {
      exportToExcel(data, {
        fileName: fileName || 'export.xlsx',
        sheetName,
        columnMapping,
        groupedHeaders,
        styled: true,
      });
    } else {
      return;
    }
  };

  return (
    <Tooltip title={tooltip}>
      <Button type="text" onClick={handleExport} className="flex items-center px-2">
        <DownloadOutlined />
      </Button>
    </Tooltip>
  );
}

export default ExcelExporter;
